function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import ParagraphComponent from "../paragraph/paragraph-component";
import ImagesGalleryComponent from "../images-gallery/images-gallery-component";
import { isContentEmpty } from "/services/paragraph-service";
import { StyledParagraphWithLogosComponent } from "./paragraph-with-logos-component.scss";
class ParagraphWithLogosComponent extends PureComponent {
    render() {
        const { paragraph, mobileImageWidthRatio, assets, shadow, textColor } = this.props;
        const screenRatios = {
            mobile: mobileImageWidthRatio
        };
        const withContent = !isContentEmpty(paragraph);
        return /*#__PURE__*/ _jsxs(StyledParagraphWithLogosComponent, {
            className: "paragraph-with-logos-component",
            children: [
                withContent && /*#__PURE__*/ _jsx("div", {
                    className: "paragraph-wrapper",
                    children: /*#__PURE__*/ _jsx(ParagraphComponent, _object_spread_props(_object_spread({}, paragraph), {
                        textColor: textColor
                    }))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "image-gallery-wrapper",
                    children: /*#__PURE__*/ _jsx(ImagesGalleryComponent, {
                        assets: assets,
                        shadow: shadow,
                        screenRatios: screenRatios
                    })
                })
            ]
        });
    }
}
export { ParagraphWithLogosComponent as default };
